import React, { createContext, useContext } from 'react';

export const GanttContext = createContext({}); // Export GanttContext

export const useData = () => useContext(GanttContext);
